//#region Libraries
//#endregion
//#region Styles
import { 
    Container, 
    ListInactivity, 
    ListItemInactivity } from "./styles";
import { Row, TitleSection } from "components/styles";
//#endregion
//#region Components
import CloseButton from "components/CloseButton/CloseButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
import TimerIcon from "icons/TimerIcon";
//#endregion

const InactivityDataFieldsDialog = ({ 
    show, toggleShow, 
    inactivity
}) => {
    return (
        <>
        <DialogAlert
            show={show}
            toggleShow={toggleShow}>
            <CloseButton onClick={() => toggleShow(false)}/>
            <Container>
                <TitleSection 
                    textAlign="center" 
                    fontWeight="900">Horas de inactividad</TitleSection>
                <ListInactivity className="custom-scrollbar primary">
                    {inactivity.map(({dayName, date, inactivities}, idx) => (
                        <ListItem 
                            key={idx}
                            dayName={dayName}
                            date={date}
                            inactivities={inactivities}
                        />
                    ))}
                </ListInactivity>
            </Container>
        </DialogAlert>
        </>
    );
}

const ListItem = ({ dayName, date, inactivities }) => {
    return (
        <ListItemInactivity>
            <header>
                <h3>{dayName}</h3>
                <h3>{date}</h3>
            </header>
            <Row className="flex-start" gap="2px">
                {inactivities.map((timeText, idx) => (
                    <div key={idx} data-role="time-item-content">
                        <span>
                            <TimerIcon/>
                        </span>
                        <span>{timeText}</span>
                    </div>
                ))}
            </Row>
        </ListItemInactivity> 
    );
}

export default InactivityDataFieldsDialog;